module.exports = __webpack_public_path__ + "static/portico_02-e7fd25e73f00a6ca1cb9003f0d89b23c.jpg";